import React from 'react';
import { Link } from 'react-router-dom';

import { OverviewAlertsChart } from './overviewAlertsChart';
import { useWorldRoutes } from '../../../routes/parts/allWorldRoutes';
import { useTranslation } from '@lib/useTypedTranslation';
import { getCategories } from './common';
import { IDevicesWithCount } from '../../../services/shared/device/batteryDevicesService';

import './style.css';
import Card from '@components/card/card';


interface IProps {
  data: IDevicesWithCount,
  isLoading?: boolean
}

export function DeviceAverageDischargeAlertsContainer(props: IProps) {
  const ns = 'translation';
  const ns1 = 'batteryOverview';
  const { t } = useTranslation([ns, ns1]);
  const routes = useWorldRoutes();
  const linkToDevices = routes.batteryEssentials.devices;

  const deviceAvgDischargeAlertMessage = <div className="devices-average-discharge-alerts-message">
    <div className="message-header">{t("BATTERY_OVERVIEW_DEVICES_TITLE", { ns: ns1 })}</div>
    <Link to={linkToDevices} className="message-link">{t('VIEW_ALL', { ns })}</Link>
  </div>;

  return (
    <Card noPadding={true} className="devices-average-discharge-alerts-container">
      <OverviewAlertsChart
        link={linkToDevices}
        data={props?.data}
        message={deviceAvgDischargeAlertMessage}
        categories={getCategories(linkToDevices)}
        isLoading={props.isLoading}
      />
    </Card>
  );
}
